import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { MonthAndYearDateInput } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import { MONTH_FIELD, YEAR_FIELD, DATE_MOVE_SUFFIX } from '../../utils/constants';
import { dateMoveRequired } from './dateMoveUtils';

class DateMoveComponentPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        ukAddressmonthField: null,
        ukAddressyearField: null
      }
    };
    this.processDateChange = this.processDateChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleDateChange(obj) {
    const { month: monthValue, year: yearValue } = obj.value;
    const { input, type } = this.props;
    const month = monthValue
      ? monthValue < 10 && monthValue.length < 2
        ? `0${monthValue}`
        : `${monthValue}`
      : '';

    this.setState({
      value: {
        ukAddressmonthField: month,
        ukAddressyearField: yearValue ? `${yearValue}` : ''
      }
    });

    input.onChange({
      [`${type}${MONTH_FIELD}`]: month,
      [`${type}${YEAR_FIELD}`]: yearValue ? `${yearValue}` : ''
    });
    yearValue &&
      this.processDateChange(
        {
          ukAddressmonthField: month,
          ukAddressyearField: yearValue ? `${yearValue}` : ''
        },
        this.props.type
      );
  }

  processDateChange(val, dateField) {
    const formVal = val || {};
    formVal[`${dateField}${MONTH_FIELD}`] = val.ukAddressmonthField;
    formVal[`${dateField}${YEAR_FIELD}`] = val.ukAddressyearField;
    if (!dateMoveRequired(formVal, this.props.type, this.props.dateIndex, this.props.formValues)) {
      this.props.onDateChange(this.props.type, val, this.props.currentIndex);
    }
  }

  componentDidMount() {
    if (
      !dateMoveRequired(
        this.props.input.value,
        this.props.type,
        this.props.dateIndex,
        this.props.formValues
      )
    ) {
      this.props.onDateChange(this.props.type, this.props.input.value, this.props.currentIndex);
    }
  }
  render() {
    const {
      type,
      meta: { touched, error },
      name,
      input
    } = this.props;
    const {
      value: { ukAddressmonthField, ukAddressyearField }
    } = this.state;
    const stateValue = {
      month: ukAddressmonthField || (input.value && input.value[`${type}${MONTH_FIELD}`]),
      year: ukAddressyearField || (input.value && input.value[`${type}${YEAR_FIELD}`])
    };
    return (
      <Content>
        {({ DateMovedToAddress, dateMoveErrorMessage }) => (
          <GenericFieldWrapper
            inputId={name}
            title={DateMovedToAddress}
            validationMessage={touched && !!error ? dateMoveErrorMessage : ''}
          >
            <MonthAndYearDateInput
              id={`${type}`}
              onChange={this.handleDateChange}
              value={stateValue}
            />
          </GenericFieldWrapper>
        )}
      </Content>
    );
  }
}

DateMoveComponentPage.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.object
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};

const DateMoveField = ({ type, formValues, onDateChange, currentIndex, dateIndex }) => (
  <Field
    name={`${type}${DATE_MOVE_SUFFIX}`}
    type={type}
    value={{ monthField: '', yearField: '' }}
    component={DateMoveComponentPage}
    validate={v => dateMoveRequired(v, type, dateIndex, formValues)}
    onDateChange={onDateChange}
    formValues={formValues}
    dateIndex={dateIndex}
    currentIndex={currentIndex}
  />
);

export default DateMoveField;
